import { Pipe, PipeTransform } from "@angular/core";

@Pipe({ name: "filterByKey" })
export class FilterByKeyPipe implements PipeTransform {
  transform(all: any[], key: string, id: number) {
    return all.filter((item) => item[key] == id);
  }
}
